<template>
  <a-modal
    v-model="syslistchange"
    title="系统菜单权限修改"
    :width="800"
	:confirmLoading="modalLoading"
    :footer="footerContent"
    @cancel="handleCancel"
  >
    <div :style="{ background: '#fff', padding: '24px', minHeight: '280px' }">
      <a-row :gutter="16">
        <a-col :span="24">
          <div class="right-panel">
            <a-spin :spinning="treeLoading" tip="菜单加载中...">
              <a-tree
                checkable
                :treeData="menuTreeData"
                :checkedKeys="selectedMenuKeys"
                :defaultExpandAll="true"
                :checkStrictly="true"
                :childrenField="'children'"
                @check="onMenuCheck"
              />
            </a-spin>
          </div>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
import { getRoleSysMenuTreeListEnabled, getSysMenuTreeListEnabled, editSysRoleAndMenu } from '@/api/common/api'

export default {
  props: {
    roleId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      syslistchange: false,
      menuTreeData: [],
      selectedMenuKeys: [],
      allMenuKeys: [],
      isInit: false,
      treeLoading:false,
	  modalLoading:false,
      fjd:[]
    }
  },
  computed: {
    footerContent() {
      return (
        <div style="text-align: right;">
          <a-button onClick={this.handleCancel} style="margin-right: 8px;">取消</a-button>
          <a-button type="primary" onClick={this.handleSave} loading={this.modalLoading}>保存</a-button>
        </div>
      )
    }
  },
  watch: {
    syslistchange(val) {
      if (val) this.loadMenuTree()
    },
    roleId(val) {
      if (this.syslistchange) this.loadMenuTree()
    }
  },
  methods: {
    getCurrentAppId() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
        return userInfo.appId || ''
      } catch (e) {
        return ''
      }
    },
    async loadMenuTree() {
      const appId = this.getCurrentAppId()
      const [allMenusRes, roleMenusRes] = await Promise.all([
        getSysMenuTreeListEnabled({ appId }),
        getRoleSysMenuTreeListEnabled({ roleId: this.roleId, appId })
      ])
      function convertTreeData(list) {
        return (list || []).map(item => ({
          title: item.text || item.name || '---',
          key: item.id,
          children: item.children ? convertTreeData(item.children) : []
        }))
      }
      this.menuTreeData = convertTreeData(allMenusRes.result || [])
      function collectAllKeys(tree) {
        let keys = []
        tree.forEach(node => {
          keys.push(node.key)
          if (node.children && node.children.length) {
            keys = keys.concat(collectAllKeys(node.children))
          }
        })
        return keys
      }
      this.allMenuKeys = collectAllKeys(this.menuTreeData)
      function collectAllCheckedKeys(tree) {
        let keys = []
        tree.forEach(node => {
          keys.push(node.id)
          if (node.children && node.children.length) {
            keys = keys.concat(collectAllCheckedKeys(node.children))
          }
        })
        return keys
      }
      const rawKeys = collectAllCheckedKeys(roleMenusRes.result || [])
      this.isInit = true
      this.selectedMenuKeys = rawKeys.filter(k => this.allMenuKeys.includes(k))
    },
    // 递归获取某节点下所有子节点key
    getAllChildKeysByKey(key, tree = this.menuTreeData) {
      let result = []
      function findNodeAndCollect(nodeList) {
        for (const node of nodeList) {
          if (node.key === key) {
            collectAllKeys(node)
            break
          } else if (node.children && node.children.length) {
            findNodeAndCollect(node.children)
          }
        }
      }
      function collectAllKeys(node) {
        if (node.children && node.children.length) {
          node.children.forEach(child => {
            result.push(child.key)
            collectAllKeys(child)
          })
        }
      }
      findNodeAndCollect(tree)
      return result
    },
    // 递归获取某节点下所有父节点key
    getAllParentKeysByKey(key, tree = this.menuTreeData, parentKeys = []) {
      for (const node of tree) {
        if (node.key === key) {
          return parentKeys
        }
        if (node.children && node.children.length) {
          const found = this.getAllParentKeysByKey(key, node.children, [...parentKeys, node.key])
          if (found) return found
        }
      }
      return null
    },
    onMenuCheck(checkedKeys, e) {
      let keys = Array.isArray(checkedKeys) ? checkedKeys : (checkedKeys.checked || [])
      
      // 处理父子联动逻辑
      const { checked, node } = e
      const nodeKey = node.eventKey
      
      // 获取当前节点的所有子节点key
      const childKeys = this.getAllChildKeysByKey(nodeKey)
      
      // 获取当前节点的所有父节点key
      const parentKeys = this.getAllParentKeysByKey(nodeKey) || []
      this.fjd = parentKeys
      let newKeys = [...keys]
      
      if (checked) {
        // 勾选时：勾选当前节点和所有子节点
        newKeys = Array.from(new Set([...newKeys, nodeKey, ...childKeys,...parentKeys]))
        
        // 检查是否需要勾选父节点（当所有子节点都被勾选时）
        parentKeys.forEach(parentKey => {
          const parentChildKeys = this.getAllChildKeysByKey(parentKey)
          const allChildrenChecked = parentChildKeys.every(childKey => newKeys.includes(childKey))
          if (allChildrenChecked) {
            newKeys.push(parentKey)
          }
        })
      } else {
        // 取消勾选时：取消当前节点和所有子节点
        newKeys = newKeys.filter(k => k !== nodeKey && !childKeys.includes(k))
        
        // 取消所有父节点的勾选
        // parentKeys.forEach(parentKey => {
        //   newKeys = newKeys.filter(k => k !== parentKey)
        // })
      }
      
      this.selectedMenuKeys = newKeys.filter(k => this.allMenuKeys.includes(k))
    },
    handleCancel() {
      this.syslistchange = false
    },
    resetMenuCheck() {
      this.selectedMenuKeys = []
    },
    async handleSave() {
      const appId = this.getCurrentAppId()
      const filteredKeys = this.selectedMenuKeys.filter(k => this.allMenuKeys.includes(k))
      const params = {
        id: this.roleId,
        appId,
        terminalid: 0,
        ids: filteredKeys
      }
      try {
		this.modalLoading=true;
        await editSysRoleAndMenu(params)
        this.$message.success('权限保存成功')
        this.syslistchange = false;
		this.modalLoading=false;
      } catch (e) {
		  this.modalLoading=false;
        this.$message.error('权限保存失败')
      }
    },
  }
}
</script>

<style scoped>
.right-panel {
  padding: 16px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  min-height: 400px;
  overflow-y: auto;
}
.action-buttons {
  margin-top: 16px;
  text-align: right;
}
.expand-collapse-buttons {
  margin-bottom: 16px;
  text-align: left;
}
</style>